const listaDeDadosPesquisa = (state) => {
    return state.items;
}

const loadingPesquisa = (state) => {
    return state.carregando
}

const paginacao = (state) => state.paginacao || null

export {
    listaDeDadosPesquisa,
    loadingPesquisa,
    paginacao
}